export default "__VITE_ASSET__OSwBGqcH__"